export default function getUrl(src) {
  return src;
}
